import {
    SET_ULTIMO_UPDATE_LISTA_SEGURADOS,
    SET_OPEN_MENU,
    SET_OPEN_SEGURADO_FORM,
    SET_ULTIMO_UPDATE_NIT
} from "../actionTypes";

const INITIAL_STATE = {
    openMenu: true,
    openSeguradoForm: false,
    cpfSeguradoSelecionado: null,
    ultimoUpdateListaSegurados: null,
    ultimoUpdateNit: null
};

// eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_OPEN_MENU:
            return {
                ...state,
                openMenu: action.payload.open
            };
        case SET_OPEN_SEGURADO_FORM:
            return {
                ...state,
                openSeguradoForm: action.payload.open,
                cpfSeguradoSelecionado: action.payload.cpf
            };
        case SET_ULTIMO_UPDATE_LISTA_SEGURADOS:
            return {
                ...state,
                ultimoUpdateListaSegurados: action.payload.data
            };
        case SET_ULTIMO_UPDATE_NIT:
            return {
                ...state,
                ultimoUpdateNit: action.payload.data
            };
        default:
            return state;
    }
};
